import { createContext } from 'react';
import { DictionaryGlobalClass } from '../pages/ChangePasswordPage/interfaces/SiteCoreDictionaryInterface';
import { ChangePasswordPageState } from '../pages/ChangePasswordPage/interfaces/ChangePasswordPageState';

const ChangePasswordContext = createContext<{rules?: ChangePasswordPageState; setRules?:(rules: ChangePasswordPageState) => void; sitecoreDictionary?: DictionaryGlobalClass}>({});
export default ChangePasswordContext;
